import { Flex, IconButton, Image, Text } from '@chakra-ui/react';
// import img from 'assets/img/team-logo (2).jpg';
import { LuArrowLeft } from 'react-icons/lu';
import { Link } from 'react-router-dom';

import { ReactNode } from 'react';
import TeamAvatar from 'components/TeamAvatar';

type TProps = {
    backHref: string;
    teamName: string;
    actions?: ReactNode;
    button?: ReactNode;
};

const TeamCardHeader = ({ teamName, backHref, actions, button }: TProps) => (
    <Flex paddingBottom="16px" alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" gap="12px" marginRight="auto">
            {backHref && (
                <IconButton
                    as={Link}
                    aria-label="back"
                    borderWidth="1px"
                    borderColor="gray.200"
                    bg="white"
                    fontSize="16px"
                    icon={<LuArrowLeft />}
                    to={backHref}
                    marginRight="12px"
                />
            )}
            <TeamAvatar src={undefined} />
            <Text color="gray.900" fontSize="24px" letterSpacing="-0.48px" lineHeight={1.5} fontWeight={700}>
                {teamName}
            </Text>
        </Flex>
        {actions}
        {button}
    </Flex>
);

export default TeamCardHeader;
